module.exports = __webpack_public_path__ + "img/63.9f21d6bf.jpg";